import { EstadosPreagendamientoEnumChoice, TABLE_CONSTANTS, useCheckPermissions, useTableColumnsPreagendamientoVentas, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { Grid } from "@mui/material";
import { GeneralTable } from "@/shared/components/ui";
import { IPreagendamiento } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { useFetchPreagendamientos } from "@/shared/actions/erp";
import CustomSearchFilterSupervisorVenta from "../../../prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";

interface AgendaTablaComponenteProps {
  estado_preagendamiento: EstadosPreagendamientoEnumChoice
}

const PreagendamientoGeneralPage = ({ estado_preagendamiento }: AgendaTablaComponenteProps) => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);

  ///* Hook
  const { columnaPreagendamiento } = useTableColumnsPreagendamientoVentas({ estado_preagendamiento: estado_preagendamiento });
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
    vendedor,
    setVendedor
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;


  ///* React Query

  const { isLoading, data: agendaRes,
    isRefetching, } = useFetchPreagendamientos(
      {
        enabled: true,
        params: {
          estado_preagendamiento: estado_preagendamiento,
          identificacion: searchTerm,
          page: pageIndex + 1,
          page_size: pageSize,
          fecha_creacion_after: dateAfter,
          fecha_creacion_before: dateBefore,
          ...filterObject,
          filterByState: false,
          user_create: vendedor
        }
      }
    );

  return (
    <Grid container spacing={2} >

      <Grid item xs={12}>
        <CustomSearchFilterSupervisorVenta
          onChange={onChangeFilter}
          value={globalFilter}
          text="por Identificación"
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
          setVendedor={setVendedor}
          //vendedor={vendedor}

        />
      </Grid>

      <Grid item xs={12}>
        <GeneralTable<IPreagendamiento>
          columns={columnaPreagendamiento}
          data={agendaRes?.data.data || []}
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={agendaRes?.data?.count}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}

          // crud
          canEdit={false}
          enableEditing={false}
          showCustomActionBtnSpace={false}
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}


        />
      </Grid>



    </Grid>


  );
}

export default PreagendamientoGeneralPage;